import React, { useEffect, useState } from "react";
import Dashboard from "features/dashboard/components";
import { Box } from "@sparrowengg/twigs-react";
import Navbar from "commons/components/navbar";
import { useSelector } from "react-redux";
import FallbackPage from "../fallback";
import { IRootState } from "commons/types";

const DashboardPage = () => {
  const userLoggedIn = useSelector((state: IRootState) => state?.userLoggedIn);
  const [showDashboard, setShowDashboard] = useState(false);
  const [isConfigPage, setIsConfigPage] = useState(false);

  useEffect(() => {
    if (userLoggedIn) {
      setShowDashboard(true);
    }
  }, [userLoggedIn]);

  return (
    <>
      {showDashboard ? (
        <Box
          css={{
            height: "100vh",
            width: "100vw",
            overflow: "hidden"
          }}
        >
          <Navbar showPreviousBtn={isConfigPage} previousBtnHandler={() => setIsConfigPage(false)} />
          <Dashboard isConfigPage={isConfigPage} setIsConfigPage={setIsConfigPage} />
        </Box>
      ) : (
        <FallbackPage />
      )}
    </>
  );
};

export default DashboardPage;
